export const CONFIDENCE_STEP_COLORS = [
  'rgb(245, 115, 22)', // 0%
  'rgb(246, 137, 34)', // 10%
  'rgb(247, 160, 46)', // 20%
  'rgb(248, 182, 58)', // 30%
  'rgb(246, 203, 68)', // 40%
  'rgb(235, 214, 69)', // 50%
  'rgb(211, 214, 69)', // 60%
  'rgb(180, 212, 70)', // 70%
  'rgb(140, 208, 74)', // 80%
  'rgb(89, 201, 88)', // 90%
  'rgb(15, 186, 130)', // 100%
] as const;

export function normalizeConfidence(confidence: number): number {
  if (confidence > 1) return Math.max(0, Math.min(1, confidence / 100));
  return Math.max(0, Math.min(1, confidence));
}

export function getConfidenceCssColor(confidence: number): string {
  const normalized = normalizeConfidence(confidence);
  const bucket = Math.round(normalized * 10);
  return CONFIDENCE_STEP_COLORS[bucket] ?? CONFIDENCE_STEP_COLORS[10];
}
